import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { VisualVO } from "./VisualVO";

export class TableListConfigVO extends VisualVO {
    public fOnly: boolean = false;
    public ignFull: boolean = false;
    public input: number = 0;
    public tabletype: number = 0;
    public help: boolean = false;
    public sort: number = 0;
    public up: number = 0;
    public down: number = 0;
}
classImplementsInterfaces(TableListConfigVO, "IInventoryVO");
